import type {ReactNode} from 'react';
import React from 'react';
import {classes, style} from './doppe-viewer-form-fields-group.st.css';
import {CommonClasses, FlexLayout} from '@wix/devzai-common-client';
import type {Evaluable} from '@wix/devzai-utils-common';
import {evaluateWhenFunction} from '@wix/devzai-utils-common';
import {reactCreateMemo} from "@wix/devzai-utils-react";

export const DoppeViewerFormFieldsGroup = reactCreateMemo(function DoppeViewerFormField(
    props: DoppeViewerFormField.Props
) {
    const {
        title,
        children,
        className,
    } = props;


    const evaluatedTitle = evaluateWhenFunction(title);
    const evaluatedChildren = evaluateWhenFunction(children);

    return (
        <div
            className={style(classes.root, {}, className, FlexLayout.column.default)}
        >
            {evaluatedTitle ? (
                <div
                    className={style(classes.title, CommonClasses.ellipsis)}
                >
                    {evaluatedTitle}
                </div>
            ) : null}
            {
                evaluatedChildren ?
                    <div
                        className={style(classes.container, {}, FlexLayout.column.default)}
                    >
                        {evaluatedChildren}
                    </div>
                    :
                    null
            }
        </div>
    );
});


export namespace DoppeViewerFormField {

    export interface PartRenderProps {
        htmlId: string;
    }

    export interface Props {
        title?: Evaluable<() => ReactNode>;
        children: Evaluable<() => ReactNode>;
        className?: string;
    }
}

